module.exports = __webpack_public_path__ + "static/img/心电PDF报告@3x.452c5d9.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/report/心电PDF报告@3x.png
// module id = 787
// module chunks = 382